import React from 'react'
import createReactClass from 'create-react-class'
import {pickBy, keys} from 'ramda'
import './report-table-panel.scss'
import {Accordion, AccordionItem} from 'react-sanfona'
import {format} from '@/util/helpers'
import ErrorBlock from '../../elements/error-block'

export default createReactClass({
  isObject (val) {
    return typeof val === 'object'
  },

  isEmptyObject (obj) {
    return this.isObject(obj) && keys(obj).length === 0
  },

  isString (key) {
    return typeof key === 'string'
  },

  renderRow (kei, val) {
    return (
      <div key={'card-row-' + kei} className='card-row'>
        <div className='no-gutter'>
          <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
            <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6'>
              <div className='row-label'>{format(kei)}</div>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6'>
              <div className='row-value'>{typeof val === typeof true ? val.toString() : val}</div>
            </div>
          </div>
        </div>
      </div>
    )
  },

  renderRowWhenArrayOfStrings (kei, val) {
    return this.renderRow(kei, val.toString())
  },

  renderValue (key, index) {
    if (index) {
      return format(key) + ' ' + index
    } else {
      return format(key)
    }
  },

  renderRowWhenObject (kei, obj, index) {
    return (
      <div key={'card-row-obj-' + kei + index} className='card-row-object'>
        <div className='card-row-object-title'>{this.renderValue(kei, index)}</div>
        {this.renderCardBody(obj)}
      </div>
    )
  },

  renderRowWhenArrayOfObjects (kei, val) {
    return (
      <div className='card-row-array' key={'card-row-' + kei}>
        <div className='card-row-array-title'>{format(kei)}</div>
        {val.map((obj, index) => {
          return this.renderRowWhenObject(kei, obj, index + 1)
        })}
      </div>
    )
  },

  renderCardBody (data) {
    return keys(data).map((key) => {
      if (Array.isArray(data[key])) {
        if (this.isObject(data[key][0])) {
          return this.renderRowWhenArrayOfObjects(key, data[key])
        } else {
          return this.renderRowWhenArrayOfStrings(key, data[key])
        }
      } else if (this.isObject(data[key])) {
        return this.renderRowWhenObject(key, data[key])
      } else {
        return this.renderRow(key, data[key])
      }
    })
  },
  renderCard (title, data, widthClass) {
    return (
      <div className={widthClass} key={'card-' + title}>
        <div className='card'>
          <div className='card-title'>{format(title)}</div>
          <div className='card-body clearfix'>
            {this.renderCardBody(data)}
          </div>
        </div>
      </div>
    )
  },

  renderTableSectionBody (sectionData, key) {
    // each direct object is displayed as card
    // so we increment the card count if it is an object
    let cardCount = 0 // used for defining the card width
    let renderRows = []
    let stringFields = {}
    let arrayFields = {}
    let objectFields = {}
    // map the data to the above declared variables as per their type
    for (let dataKey in sectionData) {
      let dataVal = sectionData[dataKey]
      // for arrays
      if (Array.isArray(dataVal)) {
        arrayFields[dataKey] = dataVal
      } else if (this.isObject(dataVal)) { // for objects
        objectFields[dataKey] = dataVal
        ++cardCount
      } else { // for strings
        stringFields[dataKey] = dataVal
      }
    }
    stringFields = {...stringFields, ...arrayFields}
    // string fields would go in to one card
    if (!this.isEmptyObject(stringFields)) {
      ++cardCount
    }
    let colWidthClass = 'col-lg-4 col-md-4 col-sm-6 col-xs-12'
    if (cardCount > 0) {
      // direct values of the section so treated as a default card
      if (!this.isEmptyObject(stringFields)) {
        renderRows.push(this.renderCard(key, stringFields, colWidthClass))
      }
      // direct object treated as a card
      if (!this.isEmptyObject(objectFields)) {
        renderRows.push(keys(objectFields).map((objKey) => {
          let kei = Array.isArray(sectionData) ? `${key} ${Number(objKey) + 1}` : objKey
          return this.renderCard(kei, objectFields[objKey], colWidthClass)
        }))
      }
    }
    return renderRows
  },
  renderTableSection (sections) {
    let renderSections = []
    for (let key in sections) {
      // check if it is an empty object
      var firstKey
      if (keys(sections[key]).length > 0) {
        if (!firstKey) {
          firstKey = key
        }
        renderSections.push(
          <AccordionItem key={key} title={format(key)} expanded={key === firstKey}>
            <div className="section-body clearfix">{this.renderTableSectionBody(sections[key], key)}</div>
          </AccordionItem>
        )
      }
    }
    return renderSections
  },

  getErrorMessage (error) {
    if (typeof error !== 'object') {
      return error
    } else {
      return error.message ? error.message : (error.messages ? error.messages[0].text : '')
    }
    // return error.message ? error.message : (error.messages ? error.messages[0].text : '')
  },

  renderTable (report) {
    let itemObjects = pickBy(this.isObject, report)
    let stringData = pickBy(this.isString, report)
    itemObjects.miscellaneousInformation = {misc: stringData}

    if (itemObjects) {
      return (
        <Accordion allowMultiple>
          {this.renderTableSection(itemObjects)}
        </Accordion>
      )
    }
  },
  render () {
    if (this.props.companyReport) {
      let {companyReport} = this.props
      const message = this.getErrorMessage(this.props.error)
      // let companySummary = prop('companySummary', companyReport.report)
      // let {creditRating: {commonValue, creditLimit: {currency, value}}} = companySummary
      return (
        <div className="container report-table-panel">
          {this.props.error
            ? <Accordion>
              <AccordionItem key='report-error' title='Company Report' expanded={!(message === '')}>
                <ErrorBlock {...this.props}/>
              </AccordionItem>
            </Accordion>
            : <div>{this.renderTable(companyReport.report)}</div>}
        </div>
      )
    }
    return <span>There is no data to display</span>
  },
})



// WEBPACK FOOTER //
// ./src/components/report-page/report-table-panel.js